import type { ReactNode } from 'react';

interface PageHeaderBlockProps {
  title: string;
  subtitle?: string;
  /** @deprecated size is no longer used — the heading always renders at text-2xl */
  size?: number;
  showActions?: boolean;
  actions?: ReactNode;
}

export default function PageHeaderBlock({
  title,
  subtitle,
  showActions = false,
  actions,
}: PageHeaderBlockProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex-1">
        {/* Title */}
        <h1 className="text-2xl font-bold tracking-tight text-foreground">
          {title}
        </h1>

        {/* Subtitle/Description */}
        {subtitle && (
          <p className="text-sm text-muted-foreground leading-relaxed mt-0.5">{subtitle}</p>
        )}
      </div>

      {/* Actions */}
      {showActions && actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
}
